export enum ResourcePanelAddToGrid
{
    DragDrop = 1,
    PlusSign = 2,
    DoubleClick = 4
}